import React from 'react'
import DayPicker from 'react-day-picker'
import moment from 'moment'
import './week-picker.css'

function getWeekDays (weekStart) {
  const days = [weekStart]
  for (let i = 1; i < 7; i += 1) {
    days.push(
      moment(weekStart)
        .add(i, 'days')
        .toDate()
    )
  }
  return days
}

function getWeekRange (date) {
  return {
    from: moment(date)
      .startOf('week')
      .toDate(),
    to: moment(date)
      .endOf('week')
      .toDate(),
  }
}

export default class WeekPicker extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      hoverRange: undefined,
      selectedDays: []
    }
  }

  componentDidMount = () => {
    let date = new Date()
    date.setDate(date.getDate() + 7)

    this.setState({
      selectedDays: getWeekDays(getWeekRange(date).from)
    })

    this.props.setSelectStartDate(getWeekRange(date).from)
  }

  handleDayChange = date => {
    //if selected day is earlier than the sunday of the earliest possible week do nothing
    let tempDate = new Date()
    tempDate.setDate(tempDate.getDate() + 7)
    const earliestPossibleDay = getWeekRange(tempDate).from
    if (date < earliestPossibleDay) {
      return
    }

    this.setState({
      selectedDays: getWeekDays(getWeekRange(date).from)
    }, () => this.props.setSelectStartDate(getWeekRange(date).from))
  }

  handleDayEnter = date => {
    this.setState({
      hoverRange: getWeekRange(date)
    })
  }

  handleDayLeave = () => {
    this.setState({
      hoverRange: undefined,
    })
  }

  calculateStartMonth = () => {
    let date = new Date()
    let initialMonth = date.getMonth()
    const currentDayOfMonth = date.getDate()
    const currentMonth = date.getMonth()
    const daysInMonth = this.daysInMonth(date.getMonth() +1, date.getFullYear())

    date.setDate(date.getDate() - (date.getDate() -1))
    const firstOfMonthDayOfWeek = date.getDay()

    const posInCalendar = currentDayOfMonth + firstOfMonthDayOfWeek

    //6 rows in calendar, 42 days
    if(firstOfMonthDayOfWeek === 6 && daysInMonth > 29) {
      if((42 - posInCalendar) < 7) {
        initialMonth = currentMonth + 1 === 11 ? 0 : currentMonth + 1
      }
    } else { //five rows, 35 days
      if((35 - posInCalendar) < 7) {
        initialMonth = currentMonth + 1 === 11 ? 0 : currentMonth + 1
      }
    }

    return initialMonth
  }

  daysInMonth = (month, year) => { // Use 1 for January, 2 for February, etc.
    return new Date(year, month, 0).getDate();
  }

  render () {
    const {hoverRange, selectedDays} = this.state
    const daysAreSelected = selectedDays.length > 0
    const hoverDays = hoverRange ? getWeekDays(hoverRange.from) : null
    const startMonth = this.calculateStartMonth()

    const modifiers = {
      hoverRange,
      selectedRange: daysAreSelected && {
        from: selectedDays[0],
        to: selectedDays[6],
      },
      hoverRangeStart: hoverRange && hoverRange.from,
      hoverRangeEnd: hoverRange && hoverRange.to,
      selectedRangeStart: daysAreSelected && selectedDays[0],
      selectedRangeEnd: daysAreSelected && selectedDays[6],
      hoverDays
    }
    const currentYear = new Date().getFullYear()
    return (
      <div className="week-picker">
        <DayPicker
          initialMonth={new Date(currentYear, startMonth)}
          fromMonth={new Date(currentYear, startMonth)}
          disabledDays={
            {
              before: getWeekRange(Date.now()).to
            }
          }
          enableOutsideDays={true}
          selectedDays={selectedDays}
          modifiers={modifiers}
          onDayClick={this.handleDayChange}
          onDayMouseEnter={this.handleDayEnter}
          onDayMouseLeave={this.handleDayLeave}
          onMonthChange={this.handleMonthChange}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/weekpicker/weekpicker.jsx